import styled from 'styled-components';

export const MessageContainer = styled.div`
  padding-bottom: 1rem;
  background-color: ${Styles.color.white};
`;
